import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import WhoCorp from "../../Componenets/WhoCorp/WhoCorp";
import Group from "../../Componenets/WhyGroup/Group";
import Usage from "../../Componenets/WhyUsage/Usage";
import InvesterCards from "../../Componenets/InvesterCard/InvesterCards";
import Join from "../../Componenets/WhyJoin/Join";
import SecondCard from "./SecondCard";

const WhyBBCorp = () => {
  return (
    <Box>
      <WhoCorp />
      <Box pt={10} pb={7}>
        <SecondCard />
      </Box>
      <Group />
      <Usage />
      <Box pb={4}>
        <InvesterCards />
      </Box>
      <Join />
    </Box>
  );
};

export default WhyBBCorp;
